/* eslint-disable import/prefer-default-export */
import { graphql } from 'graphql-schema';

// notes
// pre migration we were querying for all the rsvps above, but in the
// `usePlayerProgramInfo` hook we were not utilizing this data - only the refetch
// this leads me to believe that web is using that to 'refetch' all the rsvps
// after `onUnrsvpDropIn > unrsvpDropInMutation` fn resolves, prompting a refetch
// and grabbing the updated users rsvps

/**
 * @breadcrumb
 * web is using this query to fetch the drop in rsvps to display in web play dashboard
 * and then looks like we just call the `refetch` fn returned from this query to update the list of drop in rsvps after an `unrsvpDropIn` mutation
 */
export const MY_DROPIN_RSVPS_FOR_WEB_IMPL = graphql(`
  query myDropInRsvps($userId: uuid!) {
    registrants(
      where: {
        user: { _eq: $userId }
        is_drop_in: { _eq: true }
        drop_in_slot: { _is_null: false }
      }
      order_by: { gameByDropInGame: { start_time: desc } }
      limit: 99 # limit was here pre migration & not sure why (probably lack there of of pagination)
    ) {
      _id
      gameByDropInGame {
        _id
        start_time
      }
    }
  }
`);
